import React, { useEffect, useState, useMemo } from "react";
import { Card, Badge, Spinner, Button, Modal } from "react-bootstrap";
import { fetchOrdersByCustomerId } from "../../service/OrderService";
import { formatINR } from "../../App";
import { useToast } from "../toast/ToastProvider";
import Topbar from "./Navigations/Topbar";
import { useSelector } from "react-redux";
import Footer from "../Footer";
import { Link, useNavigate } from "react-router-dom";
import { apiUrl } from "../../config";
import "../../styles/myorder.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { getCartProductsByCustomerId } from "../../service/CartService";
import { getWishlistProductsByCustomerId } from "../../service/WishlistService";

const MyOrder = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const toast = useToast();
  const authUser = useSelector((state) => state.auth.authUser);
  const [cart, setCart] = useState([]);
  const [whislist, setWishlist] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const navigate = useNavigate();
  const fetchData = async () => {
    const cartData = await getCartProductsByCustomerId(authUser.id);
    const response = await getWishlistProductsByCustomerId(authUser.id);
    setCart(cartData);
    setWishlist(response);
  };
  const groupOrdersByOrderId = (items) => {
    const map = new Map();
    items.forEach((item) => {
      if (!map.has(item.orderId)) {
        map.set(item.orderId, {
          orderId: item.orderId,
          orderedAt: item.orderedAt,
          shippedAt: item.shippedAt,
          packedAt: item.packedAt,
          deliveredAt: item.deliveredAt,
          status: item.status,
          totalAmount: item.orderTotalAmount,
          items: [],
        });
      }
      const order = map.get(item.orderId);
      order.items.push(item);
      console.log("itemss", item);

      // order.totalAmount += item.itemTotalAmount;
    });

    return Array.from(map.values()).sort(
      (a, b) => new Date(b.orderedDate) - new Date(a.orderedDate),
    );
  };
  useEffect(() => {
    fetchData();
  }, [authUser.id]);

  useEffect(() => {
    const loadOrders = async () => {
      if (!authUser?.id) {
        setLoading(false);
        return;
      }

      try {
        const orderItems = await fetchOrdersByCustomerId(authUser.id);
        const grouped = groupOrdersByOrderId(orderItems || []);
        setOrders(grouped);
        console.log("group", grouped);
      } catch (err) {
        console.error("Error loading orders:", err);
        toast("Failed to load orders", "ERROR");
      } finally {
        setLoading(false);
      }
    };

    loadOrders();
  }, [authUser, toast]);

  const getLatestStatusDate = (order) => {
    if (order.deliveredAt)
      return { label: "Delivered On", date: order.deliveredAt };
    if (order.shippedAt) return { label: "Shipped On", date: order.shippedAt };
    if (order.packedAt) return { label: "Packed On", date: order.packedAt };
    if (order.orderedAt) return { label: "Ordered On", date: order.orderedAt };
    return { label: "No Date", date: null };
  };

  const getStatusBadge = (status) => {
    const lower = (status || "").toLowerCase();

    let label = "";
    let color = "grey";

    if (lower === "shipped") {
      label = "Shipped";
      color = "#0dcaf0";
    } else if (lower === "packed") {
      label = "Packed";
      color = "yellow";
    } else if (lower === "delivered") {
      label = "Delivered";
      color = "green";
    } else if (lower === "cancelled") {
      label = "Cancelled";
      color = "red";
    } else if (lower === "ordered") {
      label = "Ordered";
      color = "blue";
    }

    return (
      <span style={{ color: color, fontSize: "18px", fontWeight: "200" }}>
        {label}
      </span>
    );
  };

  const selectedOrder = useMemo(() => {
    return orders.find((order) => order.orderId === selectedOrderId) || null;
  }, [orders, selectedOrderId]);

  return (
    <>
      <header className="header style7">
        <Topbar />
      </header>

      <div className="container my-5">
        <div className="text-center mb-5">
          <h2
            className="fw-bold display-5 text-gradient"
            style={{ fontSize: "40px" }}
          >
            My Orders
          </h2>
          <p className="text-muted" style={{ fontSize: "25px" }}>
            Track your jewellery purchases with elegance ✨
          </p>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : orders.length === 0 ? (
          <div className="text-center py-5">
            <img
              src="https://cdn-icons-png.flaticon.com/512/4555/4555970.png"
              alt="No Orders"
              style={{ width: "150px", marginBottom: "20px" }}
            />
            <h4 className="fw-bold">No Orders Found</h4>
            <p className="text-muted">
              Start shopping to see your orders here!
            </p>
            <Link to="/" className="btn btn-primary mt-3 px-4">
              Browse Jewellery
            </Link>
          </div>
        ) : (
          <div className="orders-grid">
            {orders.map((order) =>
              order.items.map((item, index) => {
                return (
                  <Card
                    key={`${order.orderId}-${index}`}
                    className="order-card-new mb-3"
                  >
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          <img
                            src={
                              item.productImageUrl
                                ? `${apiUrl}/${item.productImageUrl.replace(/\\/g, "/")}`
                                : "/images/placeholder-product.jpg"
                            }
                            alt={item.productName}
                            className="order-main-img"
                          />

                          <div className="ms-3">
                            <h6
                              className="product-name mb-1"
                              style={{ textTransform: "capitalize" }}
                            >
                              {item.productName}
                            </h6>

                            <p className="product-meta mb-1">
                              Qty: {item.productQuantity || 1}
                            </p>

                            <p className="product-meta">
                              Ordered on:{" "}
                              {new Date(order.orderedAt).toLocaleDateString()}
                            </p>
                          </div>
                        </div>

                        <div className="text-end">
                          <h5 className="product-price">
                            {formatINR(Math.round(item.itemTotalAmount))}
                          </h5>
                          <h5>{getStatusBadge(item.status)}</h5>
                          <Link
                            to={`/orders/${order.orderId}/${item.itemId}`}
                            className="px-2 py-2"
                          >
                            <button
                              type="button"
                              className="btn btn-primary fs-4"
                            >
                              view details
                            </button>
                          </Link>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                );
              }),
            )}
            {/* <Modal
              show={selectedItem !== null}
              onHide={() => setSelectedItem(null)}
              size="lg"
              centered
              className="order-modal"
            >
              <Modal.Header closeButton>
                <Modal.Title className="fw-bold">Order Details</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                {selectedItem && (
                  <div className="order-detail-wrapper">
                    <div className="d-flex align-items-center mb-4">
                      <img
                        src={
                          selectedItem.productImageUrl
                            ? `${apiUrl}/${selectedItem.productImageUrl.replace(/\\/g, "/")}`
                            : "/images/placeholder-product.jpg"
                        }
                        alt={selectedItem.productName}
                        className="order-item-img"
                      />

                      <div className="ms-3">
                        <h5 className="fw-bold mb-2">
                          {selectedItem.productName}
                        </h5>

                        <p className="mb-1">
                          Quantity : {selectedItem.productQuantity || 1}
                        </p>

                        <p className="mb-1">
                          Price :{" "}
                          {formatINR(Math.round(selectedItem.itemTotalAmount))}
                        </p>

                        <p>{getStatusBadge(selectedItem.status)}</p>
                      </div>
                    </div>

                    <h6 className="fw-bold mb-3">Order Timeline</h6>

                    <ul className="timeline-list">
                      <li>
                        Ordered :
                        {selectedItem.orderedAt
                          ? new Date(
                              selectedItem.orderedAt,
                            ).toLocaleDateString()
                          : "Pending"}
                      </li>

                      <li>
                        Packed :
                        {selectedItem.packedAt
                          ? new Date(selectedItem.packedAt).toLocaleDateString()
                          : "Pending"}
                      </li>

                      <li>
                        Shipped :
                        {selectedItem.shippedAt
                          ? new Date(
                              selectedItem.shippedAt,
                            ).toLocaleDateString()
                          : "Pending"}
                      </li>

                      <li>
                        Delivered :
                        {selectedItem.deliveredAt
                          ? new Date(
                              selectedItem.deliveredAt,
                            ).toLocaleDateString()
                          : "Pending"}
                      </li>
                    </ul>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setSelectedItem(null)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal> */}
          </div>
        )}
      </div>

      <Footer />

      <div className="footer-device-mobile">
        <div className="wapper">
          <div className="footer-device-mobile-item device-home">
            <Link to="/" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-house"></i>
              </span>{" "}
              Home
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-cart">
            <Link to="/wishlist" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-heart"></i>
                <span className="count-icon">{whislist.length}</span>
              </span>{" "}
              Wishlist
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-cart">
            <Link to="/shopping-cart" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-shopping-cart-simple" />
                <span className="count-icon">{cart.length}</span>
              </span>{" "}
              Cart
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-user">
            <Link to="/profile" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-user"></i>
              </span>{" "}
              Account
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyOrder;
